// Extracted from galaxyControls.ts so consumers that need ONLY these
// numbers (e.g. useGalaxy's scroll math in the main page bundle) don't drag
// in galaxyControls' three.js import. The galaxy stack itself loads lazily.
export const GALAXY_CONTROLS_CONSTANTS = {
  rotation: {
    sensitivity: 0.005, // drag rotation speed (radians per pixel)
    limit: Math.PI / 3, // max vertical tilt, radians (60 degrees)
    momentumFriction: 0.95, // spin decay after drag (0-1, higher = longer)
    momentumThreshold: 0.0001, // min momentum before stop (no micro-drift)
    momentumMultiplier: 1.5, // scales initial momentum on drag release
    scrollAutoRotationMax: Math.PI * 0.5, // max scroll auto-rotation (unused)
    startRotation: 0.343830, // initial horizontal angle, radians (19.7°)
    startTilt: -0.534071, // initial vertical tilt, radians (-30.6°)
  },
  camera: {
    fov: 60,
    near: 0.00001,
    far: 2000,
    initialOffset: { x: 0.03, y: 0.01, z: 0.02 },
  },
  zoom: {
    wheelSensitivity: 0.0001, // zoom progress per wheel tick (lower = slower)
    autoZoomDuration: 600000, // full auto-zoom: 600s (10 minutes)
  },
  fadeThresholds: { // Progress values 0-1
    // Reveal order: the Earth departs FIRST, into an empty sky — in the
    // epilogue the HUD globe zooms away and fades out at the 2042 dateMarker
    // (its 2041-06-01 camera keyframe fires on that date snap, which useGalaxy
    // pins to progress 0.1 via scrollAnchors.starsAnchorProgress below). Only
    // after that departure do the stars fade in: the background field first,
    // then the larger nearby stars, then the Milky Way, its immediate
    // neighbors, the background groups, and the far wave. Aligned with
    // GALAXY_CAMERA_KEYFRAMES' three acts.
    milkyWayFadeStart: 0.42,
    milkyWayFadeEnd: 0.55,
    otherGalaxiesFadeStart: 0.58,
    otherGalaxiesFadeEnd: 0.66,
    distantGalaxiesFadeStart: 0.68,
    distantGalaxiesFadeEnd: 0.78,
    farGalaxiesFadeStart: 0.8,
    farGalaxiesFadeEnd: 0.88,
    // Both star layers start just PAST the 2042 anchor (progress 0.1): the sky
    // stays empty while the Earth zooms away, then the stars arrive slightly
    // later. Keep these starts above starsAnchorProgress or the stars will
    // beat the Earth out again.
    backgroundStarsFadeStart: 0.11,
    backgroundStarsFadeEnd: 0.18,
    // The larger "streaming past" stars follow the background field slightly.
    nearbyStarsFadeStart: 0.13,
    nearbyStarsFadeEnd: 0.22,
    // Scene-Earth fade — only visible where hideEarth isn't set (standalone
    // galaxies/audit pages; the epilogue hides the scene Earth and shows the
    // HUD globe instead). Fully out well before the stars arrive, matching
    // the epilogue's Earth-then-stars order.
    earthFadeStart: 0.015,
    earthFadeEnd: 0.06,
    tooltipEnableProgress: 0.42, // when tooltips/highlighting turn on (2043 —
    // the Milky Way anchor beat, so its tooltip is hoverable from first sight)
  },
  // Progress values useGalaxy pins the epilogue's 2042/2043 dateMarkers to.
  // Kept SEPARATE from the fade thresholds above so the two can be tuned
  // independently: the 2042 marker is the Earth-departure beat (crossing it
  // snaps the HUD date past the globe's 2041-06-01 zoom-away keyframe), and
  // the star fade-ins above start just past it, so the stars only arrive
  // after the Earth has zoomed away.
  scrollAnchors: {
    starsAnchorProgress: 0.1, // 2042 marker → Earth zooms away; stars follow just after
    galaxiesAnchorProgress: 0.42, // 2043 marker → Milky Way begins to appear
  },
  galaxyMode: {
    backgroundColor: "#C0BDAD", // bg when galaxy active (brownish beige)
    desktop: {
      startDate: "2040-01-01", // when globe fades out and galaxy fades in
      globeFadeOutDurationMs: 1000, // globe fade-out duration
      galaxyShowDelayMs: 1000, // delay galaxy fade-in (globe out first)
      galaxyFadeInDurationMs: 333, // galaxy fade-in duration
      centerOffsetX: 0.004, // galaxy viz horizontal offset
      centerOffsetY: 0.006, // galaxy viz vertical offset
    },
    mobile: {
      startDate: "2042-01-01", // when globe fades out and galaxy fades in
      globeFadeOutDurationMs: 1000, // globe fade-out duration
      galaxyShowDelayMs: 1000, // delay galaxy fade-in (globe out first)
      galaxyFadeInDurationMs: 333, // galaxy fade-in duration
      centerOffsetX: 0, // galaxy viz horizontal offset
      centerOffsetY: 0, // galaxy viz vertical offset
    },
  },
}
